import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import {
  loadSubscribeStatus, subscribeStream,
  subscriptionFormSlice
} from "@common/redux/slices/subscriptionForm.slice";
import { useDispatch } from "react-redux";
import { useDispatchThunk } from "@common/redux/dispatchThunk";
import React from "react";
import { BaseSubscribeForm } from "@kursk/components/ui/BaseSubscribeForm/BaseSubscribeForm";
import styles from "@kursk/components/pages/SingleStream/SingleStream.module.scss";

type IProps = {
  streamId: number;
}

export const SubscribeStreamsForm = ({ streamId }: IProps) => {
  const subscription = useSelectSlice(subscriptionFormSlice);
  const dispatch = useDispatch();
  const dispatchThunk = useDispatchThunk();

  React.useEffect(() => {
    dispatch(loadSubscribeStatus({}))
  }, []);

  const successBlock = (): JSX.Element => (
    <div className={styles.streams_subscribeSuccess}>
      <div className={styles.streams_subscribeSuccess_text}>
        <div>Трансляция еще не доступна.</div>
        <div>Вы подписаны на эту трансляцию.</div>
      </div>
    </div>
  );

  const handleSubmit = async (email: string) => {
    const res = await dispatchThunk(subscribeStream({ email, streamId }));
    if (!res.error) {
      return true;
    }
  }
  return <BaseSubscribeForm
    subscriptionSuccess={subscription?.streams.indexOf(streamId) !== -1}
    setSubscriptionSuccess={handleSubmit}
    title={'трансляция ещё недоступна'}
    subTitle={'Отправим вам напоминание о начале трансляции'}
    successText={'Вы подписаны. Мы отправим вам напоминание о начале трансляции.'}
    successBlock={successBlock()}
  />
}
